module.exports = __webpack_public_path__ + "img/warning_animation.07ad0696.gif";